/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import ZoneGame from './Zone';

function NflGame(props) {
    return <ZoneGame {...props} gameType="nfl" />;
}

export default NflGame;
